import { createContext, useContext } from 'react';
import en from './en';
import pt from './pt';
import es from './es';
import fr from './fr';

const locales = { en, pt, es, fr };

function detectLocale() {
  const lang = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
  if (lang.startsWith('pt')) return 'pt';
  if (lang.startsWith('es')) return 'es';
  if (lang.startsWith('fr')) return 'fr';
  return 'en';
}

export function getLocale() {
  return detectLocale();
}

export function setLocale() {
  // Locale is managed via React Context — this is a no-op kept for compatibility.
}

export function makeT(locale) {
  const strings = locales[locale] || en;
  return (key) => strings[key] ?? en[key] ?? key;
}

export const LocaleContext = createContext(detectLocale());

export function useT() {
  const locale = useContext(LocaleContext);
  return makeT(locale);
}

export const availableLocales = [
  { code: 'en', label: 'English' },
  { code: 'pt', label: 'Português' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
];
